import Vue from "vue";
import VueRouter from "vue-router";

import store from "../store/index";

import { isAfter, fromUnixTime } from "date-fns";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/Login")
  },

  {
    path: "/password-reset",
    name: "password-reset",
    component: () => import("../views/PasswordReset.vue")
  },

  {
    path: "/companies",
    name: "CompaniesList",
    component: () => import("../views/Company/Companies.vue")
  },

  {
    path: "/companies/:companyId",
    component: () => import("../views/Company/Company.vue"),
    children: [
      {
        name: "CompanyShow",
        path: "/",
        props: true,
        component: () => import("../components/Company/CompanyInfo.vue")
      },
      {
        name: "CompanyUsers",
        path: "users/",
        props: true,
        component: () => import("../components/Company/Users.vue")
      },
      {
        name: "CompanyPayments",
        path: "payments/",
        props: true,
        component: () => import("../components/Company/Payments.vue")
      },
      {
        name: "CompanyFacilities",
        path: "facilities/",
        props: true,
        component: () => import("../components/Company/Facilities.vue")
      },
      {
        name: "CompanyPricing",
        path: "pricing/",
        props: true,
        component: () => import("../views/Pricing/Pricing.vue")
      }
    ]
  },

  {
    path: "/users/",
    name: "UserList",
    component: () => import("../views/User/UserList")
  },

  {
    path: "/users/:userId",
    name: "UserShow",
    component: () => import("../views/User/UserShow.vue")
  },

  {
    path: "/users/:userId/edit",
    name: "UserEdit",
    component: () => import("../views/User/UserEdit.vue")
  },

  {
    name: "NewCompanyUser",
    path: "/companies/:companyId/new-user",
    component: () => import("../views/User/UserNew.vue")
  },

  {
    name: "AddSubscriptionPricingOverride",
    path:
      "/companies/:companyId/facilities/:facilityId/add-subscription-pricing-override",
    component: () =>
      import("../components/Company/Pricing/AddSubscriptionPricingOverride")
  },

  {
    name: "EditSubscriptionPricingOverride",
    path:
      "/companies/:companyId/facilities/:facilityId/subscription-override/:overrideId/edit",
    component: () =>
      import("../components/Company/Pricing/EditSubscriptionPricingOverride")
  },

  {
    path: "/companies/:companyId/payments/:paymentId",
    name: "paymentShow",
    component: () => import("../views/Company/Payment.vue")
  },

  {
    path: "/reporting",
    name: "Reporting",
    component: () => import("../views/Reporting.vue")
  },

  {
    path: "/financial-reporting",
    component: () => import("../views/FinancialReporting/FinancialReporting"),
    children: [
      {
        name: "FinancialDashboard",
        path: "dashboard",
        component: () => import("../views/FinancialReporting/Dashboard")
      },
      {
        name: "BillingReport",
        path: "billing",
        component: () => import("../views/FinancialReporting/Billing")
      },
      {
        name: "ActivityReport",
        path: "activity",
        component: () => import("../views/FinancialReporting/Activity")
      }
    ]
  },

  {
    path: "/downgrades",
    name: "Downgrades",
    component: () => import("../views/Downgrades")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.fullPath !== "/") {
    const authTokens = store.getters["auth/getAuthTokens"];
    if (
      !authTokens ||
      !authTokens.accessToken ||
      !authTokens.refreshToken ||
      isAfter(new Date(), fromUnixTime(authTokens.accessTokenExpiry))
    ) {
      store.dispatch("resetAllState");
      localStorage.clear();
      return next("/");
    }
  } else {
    store.dispatch("resetAllState");
    localStorage.clear();
  }

  next();
});

export default router;
